import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuthStore } from "@/app/store/auth.store";

export function ProtectedRoute() {
  const { accessToken, isBootstrapping } = useAuthStore();
  const location = useLocation();

  // The access token is memory-only, so on a hard refresh there is always a
  // moment with no token and a refresh call in flight. Redirecting during that
  // window would bounce every user to /login on every reload.
  if (isBootstrapping) {
    return (
      <div className="flex h-full items-center justify-center">
        <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" />
        <span className="sr-only">Loading</span>
      </div>
    );
  }

  if (!accessToken) {
    // Remember where they were headed so login can return them there.
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  return <Outlet />;
}

export function PublicOnlyRoute() {
  const { accessToken, isBootstrapping } = useAuthStore();
  if (isBootstrapping) return null;
  if (accessToken) return <Navigate to="/" replace />;
  return <Outlet />;
}
